export default {
  fr: {
    title: 'Fixez le prix de vos vêtements de seconde main | Estimez le prix de revente de votre article',
    description:
      // tslint:disable-next-line: max-line-length
      'Estimez le prix de votre article avec notre calculateur de revente ✅ Rapide et facile!',
  },
  en: {
    title: 'Price your Used Clothes | Estimate Resale Price of your item',
    description:
      // tslint:disable-next-line: max-line-length
      'Find out the estimated selling price of your item by using our resale calculator ✅ Quick and Easy',
  },
  it: {
    title: 'Stabilisci il prezzo dei tuoi vestiti usati | Valuta il prezzo di rivendita del tuo articolo',
    description:
      // tslint:disable-next-line: max-line-length
      'Scopri il prezzo di vendita stimato del tuo articolo usando il nostro calcolatore ✅ Semplice e veloce',
  },
  de: {
    title:
      'Bestimmen Sie den Preis für Ihre Second-Hand-Kleidung | Schätzen Sie den Wiederverkaufspreis Ihres Artikels',
    description:
      // tslint:disable-next-line: max-line-length
      'Ermitteln Sie den geschätzten Verkaufspreis Ihres Artikels mit unserem Kalkulator ✅ Schnell und einfach',
  },
  es: {
    title: 'Establece el precio de tus prendas de segunda mano | Calcula el precio de reventa de tu artículo',
    description:
      // tslint:disable-next-line: max-line-length
      'Descubre el precio estimado de venta de tu artículo con nuestra calculadora ✅ Rápido y fácil',
  },
  us: {
    title: 'Price your Used Clothes | Estimate Resale Price of your item',
    description:
      // tslint:disable-next-line: max-line-length
      'Find out the estimated selling price of your item by using our resale calculator ✅ Quick and Easy',
  },
  ko: {
    title: '명품 리세일 스토어 베스티에르 콜렉티브에서 중고 패션 상품을 찾아보세요',
    description:
      // tslint:disable-next-line: max-line-length
      'VestiaireCollective.com, 최고의 중고 패션 플랫폼으로 리테일가에서 30%에서 최대 70% 가격의 상품을 찾을 수 있습니다. ✅ 구매! 판매! 공유! ✅ 100%의 상품들이 전문가들에의하 직접 큐레이션되고 관리됩니다!',
  },
};
